<template>
  <div class="home">
      <div class="columns is-centered">
        <div v-if='isLoading'>
            <Loader></Loader>
        </div>
        <div v-else>
            <div class="columns is-vcentered">
                <div class="column is-one-quarter">
                <h1>{{company.name}}</h1>
                <p>Monthly SEQu-DOC limit: {{company.limit}} Checkups</p>
                <p>Balance: {{company.balance}} checkups</p>
            </div>
            <div class="column">
                <div class="bbbox">
                    <p class="is-size-2 has-text-primary">Register a patient</p>
                    <b-field label="Enter the person's cellphone number"
                    :type="patientTel && patientTel.length > 10 ? 'is-danger' : ''"
                    :message="patientTel && patientTel.length > 10 ? 'Please do not include the 0. Example: 9171234567' : ''">
                        <b-input
                        placeholder="Format: 9171234567"
                        v-model="patientTel">
                        </b-input>
                    </b-field>
                    <p class="is-size-6">The system will text the patient when he/she is ready to be served.</p>
                    <b-button @click="createPatient" :disabled="!patientTel || patientTel.length !== 10">
                        Register
                    </b-button>
                </div>
            </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import BButton from "buefy/src/components/button/Button";
import Loader from "../components/loader";
export default {
  name: 'Home',
    components: {Loader, BButton},
    data() {
      return {
          patientTel: null,
          isLoading: false,
          company: null
      }
    },
    methods: {
        promptLogin() {
          this.$router.push({name: 'Login'})
        },
        createPatient() {
            const vm = this;
            vm.isLoading = true;
            vm.axios.post(`${vm.$host}/lista?access_token=${localStorage.token}`, {tel: vm.patientTel})
                .then(function (res) {
                    vm.isLoading = false;
                    alert('Patient loading successful')
                    vm.patientTel = null
                    vm.getCompany()
                })
                .catch(function (err) {
                    if (err.response.status === 401) {
                        vm.promptLogin()
                    } else {
                        alert(err)
                        vm.isLoading = false;
                    }
                })
        },
        getCompany() {
            const vm = this;
            vm.isLoading = true;
            vm.axios.get(`${vm.$host}/company/${localStorage.companyId}?access_token=${localStorage.token}`, {tel: vm.patientTel})
                .then(function (res) {
                    vm.isLoading = false;
                    vm.company = res.data;
                })
                .catch(function (err) {
                    if (err.response.status === 401) {
                        vm.promptLogin()
                    } else {
                        alert(err)
                    }
                })
        }
    },
    mounted() {
      if (!localStorage.token) {
          this.promptLogin()
      } else {
          this.getCompany()
      }
    }
}
</script>
